<!-- ── Dialog mode: header + scans panel only ───────────────── -->
@if (isDialogMode) {
  <h2 mat-dialog-title class="dialog-title">
    <mat-icon>receipt_long</mat-icon>
    Skany kart – {{ dialogCampaignName }}
    <button mat-icon-button class="dialog-close" (click)="dialogRef.close()" matTooltip="Zamknij">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content class="dialog-scans-content">
    <!-- Filter bar -->
    <div class="filters-bar">
      <mat-form-field appearance="outline" class="filter-field">
        <mat-label>Szukaj osoby / użytkownika</mat-label>
        <input matInput [(ngModel)]="filterText" (keyup.enter)="applyFilter()" placeholder="Wpisz imię, nazwisko...">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
      <mat-form-field appearance="outline" class="filter-field filter-field--sm">
        <mat-label>Typ</mat-label>
        <mat-select [(ngModel)]="filterType" (selectionChange)="applyFilter()">
          @for (t of scanTypeOptions; track t) {
            <mat-option [value]="t.value">{{ t.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="filter-field filter-field--sm">
        <mat-label>Data od</mat-label>
        <input matInput [matDatepicker]="pickerFromD" [(ngModel)]="filterDateFromDate" (dateChange)="applyFilter()" placeholder="yyyy-MM-dd" readonly>
        <mat-datepicker-toggle matSuffix [for]="pickerFromD"></mat-datepicker-toggle>
        <mat-datepicker #pickerFromD></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline" class="filter-field filter-field--sm">
        <mat-label>Data do</mat-label>
        <input matInput [matDatepicker]="pickerToD" [(ngModel)]="filterDateToDate" (dateChange)="applyFilter()" placeholder="yyyy-MM-dd" readonly>
        <mat-datepicker-toggle matSuffix [for]="pickerToD"></mat-datepicker-toggle>
        <mat-datepicker #pickerToD></mat-datepicker>
      </mat-form-field>
      <button mat-icon-button (click)="applyFilter()" matTooltip="Filtruj"><mat-icon>filter_list</mat-icon></button>
      <button mat-icon-button (click)="clearFilters()" matTooltip="Wyczyść filtry"><mat-icon>filter_list_off</mat-icon></button>
    </div>
    @if (scansLoading) {
      <div class="center-spinner"><mat-spinner diameter="32"></mat-spinner></div>
    }
    @if (scansError) {
      <div class="error-msg">{{ scansError }}</div>
    }
    @if (!scansLoading && scans.length) {
      <mat-table [dataSource]="scans" class="scans-table">
        <ng-container matColumnDef="person_name">
          <mat-header-cell *matHeaderCellDef>Osoba</mat-header-cell>
          <mat-cell *matCellDef="let s">{{ s.person_name }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="user_name">
          <mat-header-cell *matHeaderCellDef>Użytkownik</mat-header-cell>
          <mat-cell *matCellDef="let s">{{ s.user_name }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="type">
          <mat-header-cell *matHeaderCellDef>Typ</mat-header-cell>
          <mat-cell *matCellDef="let s">
            <span class="type-badge" [class.type-badge--ENTRY]="s.type === 'ENTRY'" [class.type-badge--TRANSACTION]="s.type === 'TRANSACTION'">
              <mat-icon>{{ s.type === 'ENTRY' ? 'how_to_reg' : 'point_of_sale' }}</mat-icon>
              {{ s.type === 'ENTRY' ? 'Wejście' : s.type === 'TRANSACTION' ? 'Transakcja' : s.type }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>Nazwa</mat-header-cell>
          <mat-cell *matCellDef="let s">{{ s.name }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="score">
          <mat-header-cell *matHeaderCellDef>Punkty</mat-header-cell>
          <mat-cell *matCellDef="let s"><span class="score-val"><mat-icon>star</mat-icon>{{ s.score }}</span></mat-cell>
        </ng-container>
        <ng-container matColumnDef="amount">
          <mat-header-cell *matHeaderCellDef>Kwota</mat-header-cell>
          <mat-cell *matCellDef="let s">{{ s.amount != null ? (s.amount | number:'1.2-2') + ' zł' : '—' }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="created">
          <mat-header-cell *matHeaderCellDef>Data</mat-header-cell>
          <mat-cell *matCellDef="let s">{{ s.created | date:'yyyy-MM-dd HH:mm' }}</mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedScanColumns"></mat-header-row>
        <mat-row *matRowDef="let s; columns: displayedScanColumns;"></mat-row>
      </mat-table>
    }
    @if (!scansLoading && !scans.length && !scansError) {
      <p class="empty-msg">Brak logów skanów dla tej kampanii.</p>
    }
    @if (scansTotal > 0) {
      <mat-paginator
        [length]="scansTotal"
        [pageIndex]="page"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        (page)="onPageChange($event)"
        showFirstLastButtons>
      </mat-paginator>
    }
  </mat-dialog-content>
}

<!-- ── Standalone page mode ───────────────────────────────── -->
@if (!isDialogMode) {
  <div class="campaign-scans-container">
    <div class="header">
      <h2>Logi skanów kampanii</h2>
    </div>
    @if (campaignsLoading) {
      <div class="center-spinner">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    }
    @if (campaignsError) {
      <div class="error-msg">{{ campaignsError }}</div>
    }
    @if (!campaignsLoading && campaigns.length) {
      <mat-table
        [dataSource]="campaigns"
        multiTemplateDataRows
        class="campaigns-table">
        <!-- Active column -->
        <ng-container matColumnDef="active">
          <mat-header-cell *matHeaderCellDef>Akt.</mat-header-cell>
          <mat-cell *matCellDef="let c">
            <mat-icon [style.color]="c.active ? '#2E7D32' : '#bbb'">
              {{ c.active ? 'check_circle' : 'cancel' }}
            </mat-icon>
          </mat-cell>
        </ng-container>
        <!-- Name column -->
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>Nazwa kampanii</mat-header-cell>
          <mat-cell *matCellDef="let c">{{ c.name }}</mat-cell>
        </ng-container>
        <!-- Valid column -->
        <ng-container matColumnDef="valid">
          <mat-header-cell *matHeaderCellDef>Ważna do</mat-header-cell>
          <mat-cell *matCellDef="let c">{{ c.valid | date:'yyyy-MM-dd' }}</mat-cell>
        </ng-container>
        <!-- Toggle logs column -->
        <ng-container matColumnDef="scans">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let c" (click)="$event.stopPropagation()">
            <button mat-stroked-button class="toggle-btn"
              [class.toggle-btn--active]="expandedCampaignId === c.id"
              (click)="toggleScans(c)">
              <mat-icon>{{ expandedCampaignId === c.id ? 'keyboard_arrow_up' : 'receipt_long' }}</mat-icon>
              {{ expandedCampaignId === c.id ? 'Ukryj logi' : 'Pokaż logi skanów' }}
            </button>
          </mat-cell>
        </ng-container>
        <!-- Expanded detail row column -->
        <ng-container matColumnDef="expandedDetail">
          <mat-cell *matCellDef="let c" [attr.colspan]="displayedCampaignColumns.length" class="detail-cell">
            <div class="detail-wrapper" [class.detail-wrapper--open]="expandedCampaignId === c.id">
              @if (expandedCampaignId === c.id) {
                <div class="scans-panel">
                  <!-- Filter bar -->
                  <div class="filters-bar">
                    <mat-form-field appearance="outline" class="filter-field">
                      <mat-label>Szukaj osoby / użytkownika</mat-label>
                      <input matInput [(ngModel)]="filterText" (keyup.enter)="applyFilter()" placeholder="Wpisz imię, nazwisko...">
                      <mat-icon matSuffix>search</mat-icon>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="filter-field filter-field--sm">
                      <mat-label>Typ</mat-label>
                      <mat-select [(ngModel)]="filterType" (selectionChange)="applyFilter()">
                        @for (t of scanTypeOptions; track t) {
                          <mat-option [value]="t.value">{{ t.label }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="filter-field filter-field--sm">
                      <mat-label>Data od</mat-label>
                      <input matInput [matDatepicker]="pickerFrom" [(ngModel)]="filterDateFromDate" (dateChange)="applyFilter()" placeholder="yyyy-MM-dd" readonly>
                      <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
                      <mat-datepicker #pickerFrom></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="filter-field filter-field--sm">
                      <mat-label>Data do</mat-label>
                      <input matInput [matDatepicker]="pickerTo" [(ngModel)]="filterDateToDate" (dateChange)="applyFilter()" placeholder="yyyy-MM-dd" readonly>
                      <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
                      <mat-datepicker #pickerTo></mat-datepicker>
                    </mat-form-field>
                    <button mat-icon-button (click)="applyFilter()" matTooltip="Filtruj">
                      <mat-icon>filter_list</mat-icon>
                    </button>
                    <button mat-icon-button (click)="clearFilters()" matTooltip="Wyczyść filtry">
                      <mat-icon>filter_list_off</mat-icon>
                    </button>
                  </div>
                  <!-- Scans loading spinner -->
                  @if (scansLoading) {
                    <div class="center-spinner">
                      <mat-spinner diameter="32"></mat-spinner>
                    </div>
                  }
                  <!-- Scans error -->
                  @if (scansError) {
                    <div class="error-msg">{{ scansError }}</div>
                  }
                  <!-- Scans table -->
                  @if (!scansLoading && scans.length) {
                    <mat-table [dataSource]="scans" class="scans-table">
                      <ng-container matColumnDef="person_name">
                        <mat-header-cell *matHeaderCellDef>Osoba</mat-header-cell>
                        <mat-cell *matCellDef="let s">{{ s.person_name }}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="user_name">
                        <mat-header-cell *matHeaderCellDef>Użytkownik</mat-header-cell>
                        <mat-cell *matCellDef="let s">{{ s.user_name }}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="type">
                        <mat-header-cell *matHeaderCellDef>Typ</mat-header-cell>
                        <mat-cell *matCellDef="let s">
                          <span class="type-badge" [class.type-badge--entry]="s.type === 'ENTRY'" [class.type-badge--transaction]="s.type === 'TRANSACTION'">
                            <mat-icon>{{ s.type === 'ENTRY' ? 'how_to_reg' : 'point_of_sale' }}</mat-icon>
                            {{ s.type === 'ENTRY' ? 'Wejście' : s.type === 'TRANSACTION' ? 'Transakcja' : s.type }}
                          </span>
                        </mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="name">
                        <mat-header-cell *matHeaderCellDef>Nazwa</mat-header-cell>
                        <mat-cell *matCellDef="let s">{{ s.name }}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="score">
                        <mat-header-cell *matHeaderCellDef>Punkty</mat-header-cell>
                        <mat-cell *matCellDef="let s">
                          {{ s.score }}
                        </mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="amount">
                        <mat-header-cell *matHeaderCellDef>Kwota</mat-header-cell>
                        <mat-cell *matCellDef="let s">{{ s.amount != null ? (s.amount | number:'1.2-2') + ' zł' : '—' }}</mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="created">
                        <mat-header-cell *matHeaderCellDef>Data</mat-header-cell>
                        <mat-cell *matCellDef="let s">{{ s.created | date:'yyyy-MM-dd HH:mm' }}</mat-cell>
                      </ng-container>
                      <mat-header-row *matHeaderRowDef="displayedScanColumns"></mat-header-row>
                      <mat-row *matRowDef="let s; columns: displayedScanColumns;"></mat-row>
                    </mat-table>
                  }
                  @if (!scansLoading && !scans.length && !scansError) {
                    <p class="empty-msg">
                      Brak logów skanów dla tej kampanii.
                    </p>
                  }
                  <!-- Paginator -->
                  @if (scansTotal > 0) {
                    <mat-paginator
                      [length]="scansTotal"
                      [pageIndex]="page"
                      [pageSize]="pageSize"
                      [pageSizeOptions]="pageSizeOptions"
                      (page)="onPageChange($event)"
                      showFirstLastButtons>
                    </mat-paginator>
                  }
                </div>
              }
            </div>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedCampaignColumns"></mat-header-row>
        <mat-row *matRowDef="let c; columns: displayedCampaignColumns;"
          class="campaign-row"
          [class.campaign-row--expanded]="expandedCampaignId === c.id">
        </mat-row>
        <mat-row *matRowDef="let c; columns: ['expandedDetail'];"
          class="detail-row"
          [class.detail-row--visible]="expandedCampaignId === c.id">
        </mat-row>
      </mat-table>
    }
    @if (!campaignsLoading && !campaigns.length && !campaignsError) {
      <p class="empty-msg">
        Brak kampanii.
      </p>
    }
  </div>
}
